<template>
  <v-row justify="center">
    <v-col class="auth-container">
      <v-row class="ma-2"><slot name="logo"></slot></v-row>

      <v-card class="elevation-12" tile :loading="loading">
        <v-card-title>
          <h1>{{ title }}</h1>
        </v-card-title>
        <v-card-subtitle class="pt-2">
          {{ loading ? 'Please wait...' : 'Please choose a company' }}
        </v-card-subtitle>
        <v-divider></v-divider>

        <v-list v-if="!emptyList">
          <template v-for="c in companies">
            <v-list-item @click="selectCompany(c)" :key="c.id">
              <v-list-item-content>
                <v-list-item-title
                  v-text="c.name"
                  class="text-section-subtitle"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-card-text v-else>
          <p>
            Ooops... It seems you don't have access to a company. Please ask
            your manageter to invite you.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="logout()" class="button"
            >Logout</v-btn
          >
        </v-card-actions>
      </v-card>
      <v-row align="center" justify="center">
        <v-col class="text-body-light color--inactive" cols="12">
          <v-row align="center" justify="center"> or </v-row>
          <v-row align="center" justify="center">
            <router-link text class="color--inactive" :to="{ name: 'register' }"
              >Create new company</router-link
            ></v-row
          ></v-col
        ></v-row
      >
    </v-col>
  </v-row>
</template>

<script>
import { auth } from '@/firebaseConfig'
import { mapGetters } from 'vuex'

export default {
  name: 'Launchpad',
  data() {
    return {
      emptyList: false,
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'userScopes',
      'companyId',
      'userCompaniesLoading',
      'userCompanies',
    ]),
    companies() {
      return this.userCompanies
    },
    loading() {
      return this.userCompaniesLoading
    },
    subdomain() {
      if (location.host.split('.').length > 2) {
        return location.host.split('.')[0]
      } else {
        this.currentCompany?.subdomain ?? undefined
      }
      return undefined
    },
    title() {
      if (!this.currentUser.displayName) {
        return 'Hello'
      }
      return 'Hello ' + this.currentUser.displayName?.split(' ')[0] ?? ''
    },
  },
  methods: {
    selectCompany(company) {
      this.$store.commit('setCurrentCompany', company)
      if (!company.subdomain || this.subdomain) {
        this.$router.push('/')
      } else {
        const newLocation = `${location.protocol}//${company.subdomain}.${location.host}/`
        window.location.href = newLocation
      }
    },
    logout() {
      auth
        .signOut()
        .then(() => {
          this.$store.dispatch('clearState')
          this.$router.push({ name: 'login' })
        })
        .catch((err) => {
          alert(err)
        })
    },
  },
  watch: {
    userCompanies(newVal) {
      if (newVal.length === 1 && !this.companyId) {
        this.selectCompany(newVal[0])
      } else if (newVal.length === 0) {
        this.emptyList = true
      }
    },
  },
}
</script>


<style lang="sass" scoped>
.alternate-row
  background-color: adjust-color($primary, $alpha: -0.95)
</style>